exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3-rOzZ7mANTzg8V2bJ65Tp .popover-content {\n    padding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"customPopover": "_3-rOzZ7mANTzg8V2bJ65Tp"
};